<template>
  <div
    layout="column"
    layout-align="center center"
    class="login-container"
    flex
  >
    <div
      v-if="!loading"
      layout="column"
      layout-align="center center"
      class="width-100-mobile"
      flex
    >
      <div
        layout="row"
        layout-align="center center"
        class="hidden-sm-and-down"
      >
        <img
          src="@/assets/logo.png"
          style="max-height: 300px; position: relative; top: -30px; background: white"
        >
      </div>
      <v-card
        class="login-card mb-5"
        flat
      >
        <v-card-text layout="column">
          <v-form
            ref="loginForm"
            layout="column"
            class="mx5-pc"
          >
            <div class="display-1 secondary--text font-weight-medium text-uppercase my-4">{{$t("login.title")}}</div>
            <v-text-field
              type="email"
              ref="emailField"
              outline
              :label='$t("login.email")'
              single-line
              flex
              class="mb-2"
              hide-details
              v-model="auth.email"
            ></v-text-field>
            <v-text-field
              ref="pwField"
              @keyup.enter="login"
              hide-details
              outline
              :label='$t("login.pw")'
              single-line
              type="password"
              v-model="auth.password"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions
          layout="row"
          layout-align="end end"
          class="mx5-pc mr2-mobile mb-3"
        >
          <div
            layout="column"
            layout-align="center center"
          >
            <v-btn
              depressed
              color="primary"
              large
              @click="login"
            ><span style="text-transform: none">{{$t("login.btn")}}</span></v-btn>
            <div class="mt-2">
              <router-link
                class="black--text"
                :to="{name: 'reset-password-index'}"
              >{{$t("login.forgot")}}</router-link>
            </div>
          </div>
        </v-card-actions>
      </v-card>
      <div class="hidden-sm-and-down upper-relative">
        {{$t("_.supported")}}
      </div>
      <div
        class="hidden-sm-and-down upper-relative"
        layout="row"
        layout-align="center center"
      >
        <img
          src="@/assets/GOUV_MENJE.png"
          width="400"
        >
      </div>
    </div>
  </div>
</template>

<script>
import Auth from '~/plugins/auth'
import EventBus from '@/plugins/eventbus'
import platform from "platform/platform.js"
import Auths from '@/api/auth'

export default {
  data () {
    return {
      auth: {
        email: null,
        password: null
      },
      loading: false
    }
  },

  mounted () {
    if (Auth.authenticated) {
      this.loading = true
      Auths.stillConnected().then(res => {
        if (res.data && res.data == 1) {
          this.$router.push({ name: 'my-wall' })
          this.loading = false
        } else {
          Auth.localLogout()
          this.loading = false
        }
      }, () => {
        Auth.localLogout()
        this.loading = false
      })
    }
    this.$refs.emailField.focus()
  },

  methods: {
    login () {
      let params = {
        email: this.auth.email,
        password: this.auth.password,
        info: {
          browser_name: platform.name,
          browser_ver: platform.version,
          os: platform.os ? platform.os.family : '',
          device_brand: platform.manufacturer ? platform.manufacturer : '',
          device_name: platform.product ? platform.product : ''
        }
      }
      Auth.login(params).then((res) => {
        this.$store.commit("LOAD_CIRCLES", true)

        let dest = this.$store.state.destination
        let dest2 = this.$route.query.redirect

        if (dest && dest != "/" && dest != "/login") {//Suite à un 401
          this.$store.commit('CLEAR_DESTINATION')
          this.$router.push(dest)
        }
        else if (dest2 && dest2 != "/" && dest2 != "/login") {//Si on était pas du tout co
          this.$router.push(dest2)
        }
        else {
          this.$router.push({ name: 'my-wall' })
        }

        if (res && res.lang_id) {
          this.$store.commit('SET_LANG', res.lang_id)
          this.$i18n.locale = res.lang_id
          this.$vuetify.lang.current = res.lang_id
          EventBus.$emit('lang-changed')
        }
      })

      return false
    },

    passwordForgotten () {
      this.$router.push({ name: 'login-forgot' })
    }
  },
}
</script>

<style scoped>
.login-card {
  width: 600px;
  background-color: rgba(241, 241, 241, 0.7);
}

.login-container {
  /*background: url('/home.png') no-repeat center center;
  background-size: cover;*/
  position: relative;
  padding-bottom: 50px;
}

.upper-relative {
  position: relative;
  top: -60px;
}

@media screen and (max-width: 960px) {
  .login-card {
    width: 100%;
  }

  .login-container {
    padding-bottom: 0px;
  }

  body,
  html {
    overflow: hidden;
  }
}
@media screen and (min-width: 960px) {
  .login-card {
    top: -60px;
  }
}
</style>